import React, { useState } from 'react';
import { Button, Skeleton } from 'antd';
import classNames from 'classnames';
import { ArrowLeftIcon, ArrowRightIcon, CheckCircleIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { useGetRegions } from 'modules/global';

import { nextStep, prevStep, setRegion } from '../store';

const RegionSelectStep = () => {
  const t = useTranslations();
  const regionId = useAppSelector(state => state.authModal.data.region);
  const [selected, setSelected] = useState<number | null>(regionId);
  const dispatch = useAppDispatch();
  const { regions, isLoading } = useGetRegions({ isNotAll: true });

  const onContinue = () => {
    dispatch(setRegion(selected));
    dispatch(nextStep());
  };

  return (
    <div className="flex h-[94vh] sm:h-full w-full flex-col justify-between p-6">
      <div>
        <h3 className="mb-2 text-3xl font-semibold">{t("qaysi_hududdansiz")}</h3>
        <p className="text-sm">{t("qaysi_hududdansiz_desc")}</p>
        <div className="mt-10 flex flex-wrap gap-4 ">
          {isLoading
            ? [...Array(10)].map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Skeleton.Button key={index} active style={{ width: 120, height: 40, borderRadius: 12 }} />
              ))
            : regions?.map(option => (
                <div
                  key={option.value}
                  onClick={() => setSelected(option.value)}
                  className={classNames(
                    'flex cursor-pointer items-center gap-1 rounded-xl border px-4 py-1.5 transition',
                    selected === option.value ? 'border-green-600 bg-green-50' : 'border border-gray-300 bg-gray-50'
                  )}
                >
                  {selected === option.value && <CheckCircleIcon size="16" />}
                  <p className="font-medium">{option.label}</p>
                </div>
              ))}
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="text-gray-400">5/8</div>
        <div className="flex items-center gap-3">
          <Button
            onClick={() => dispatch(prevStep())}
            className="!py-5.5 !rounded-lg !border-none !border-transparent !bg-gray-100 !px-4 hover:!text-black"
          >
            <div className="mt-0.5 ">
              <ArrowLeftIcon size="18" />
            </div>
            {t('ortga')}
          </Button>
          <Button
            onClick={onContinue}
            disabled={!selected}
            className="!rounded-lg !border-transparent !bg-green-500 !px-5 !py-5 !text-white disabled:!bg-gray-100 disabled:!text-gray-400"
          >
            {t('davom_etish')}
            <div className="mt-0.5 ">
              <ArrowRightIcon />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RegionSelectStep;
